<div class="table-container">
    <div class="header-container">
      <div class="title-container tw-items-center">
        <h3 class="mb-0">{{ title }}</h3>
        <div *ngIf="enableEditButton()" class="edit" mat-raised-button color="primary">
          <div class="edit-text-container" (click)="onEditClicked()">
            <span>Edit</span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!loading" class="content-container new-fd-view-table">
      <table class="data-table-values tw-w-full">

        <!-- Finances Table -->
        <ng-container *ngIf="title === 'Finances'">
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Annual Profits</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Annual Profits') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Total Business Debt</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Bus. Debt Amount') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Monthly Profits</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Monthly Profits') ? '$' + (getValueFromDataList('Monthly Profits') | number) : '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Min Monthly Payments</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Monthly Debt Payments') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Annual Revenue</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Annual Revenue') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Bankruptcy Status</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Bk. Status') || 'None' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Monthly Revenue</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Monthly Sales') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Bankruptcy Status Date</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Bk. Discharge Date') || 'N/A' }}</span>
                </td>
            </tr>
        </ng-container>

        <!-- Borrower Credit Table -->
        <ng-container *ngIf="title === 'Borrower Credit'">
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left"># Public Records</span>
                    <span class="tw-text-right">{{ getValueFromDataList('# Public Records') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">30 Day Delinquencies</span>
                    <span class="tw-text-right">{{ getValueFromDataList('30 Day Delinquencies') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Installment Balance</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Installment Balance') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">60 Day Delinquencies</span>
                    <span class="tw-text-right">{{ getValueFromDataList('60 Day Delinquencies') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Revolving Balance</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Revolving Balance') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">90 Day Delinquencies</span>
                    <span class="tw-text-right">{{ getValueFromDataList('90 Day Delinquencies') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Real Estate Balance</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Real Estate Balance') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left"># Derogatory Marks</span>
                    <span class="tw-text-right">{{ getValueFromDataList('# Derog Marks') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">PCT Revolving Availability</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Pct Revolving Avail') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">6 Months Inquiries</span>
                    <span class="tw-text-right">{{ getValueFromDataList('6 Month Inquiries') || '-' }}</span>
                </td>
            </tr>
        </ng-container>

        <!-- Tradelines -->
        <ng-container *ngIf="title === 'Open Tradelines'">
            <tr class="tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-full tw-py-3 tw-pr-6 tw-pl-4">
                    <span><span class="tradelines-header-grey">Minimum Monthly Payment:</span> {{ minimumMonthlyPayment | currency }}</span>
                    <span><span class="tradelines-header-grey">Number of Trade Items:</span> {{ tradelineCount }}</span>
                </td>
            </tr>
            <ng-container *ngFor="let tradeline of creditReport?.tradeLines; let i = index;">
                <tr class="tw-flex tw-w-full" *ngIf="i == 0 || i % 2 == 0">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">{{ tradeline?.subscriberDisplayName }}</span>
                        <span class="tw-text-right">{{ tradeline?.monthlyPaymentAmount | currency }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">{{ creditReport?.tradeLines[i+1]?.subscriberDisplayName }}</span>
                        <span class="tw-text-right">{{ creditReport?.tradeLines[i+1]?.monthlyPaymentAmount | currency }}</span>
                    </td>
                </tr>
            </ng-container>
        </ng-container>

        <!-- Business Personnel -->
        <ng-container *ngIf="title === 'Business Personnel'">
            <ng-container *ngFor="let contact of contacts">
                <tr class="tw-w-full">
                    <td class="tw-flex tw-justify-start tw-items-center tw-w-full tw-py-6 tw-px-3">
                        <span class="tw-text-lg">{{ contact.first }} {{ contact.last }}</span>
                        <span class="tw-ml-3 tw-text-sm primary-pill" *ngIf="!!(contact.isPrimary)">Primary Contact</span>
                        <span class="tw-ml-3 tw-text-sm primary-pill" *ngIf="!!(contact.isBusiness)">Business</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Title / Role</span>
                        <span class="tw-text-right">{{ contact?.title ? contact.title : '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Ownership Percentage</span>
                        <span class="tw-text-right">{{ contact?.percentOwnership ? contact.percentOwnership + '%' : '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Street Address</span>
                        <span class="tw-text-right">{{ contact?.street ? contact.street + (contact?.street2 ? ' ' + contact.street2 : '') : '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Mobile Number</span>
                        <span class="tw-text-right">{{ contact?.mobilePhone ? (contact.mobile_phone_country_code.country.countryCode + ' ' + (contact.mobilePhone | phone: contact.mobile_phone_country_code.country.countryCode)) : '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">City / State</span>
                        <span class="tw-text-right">{{ contact?.city ? contact.city : '-' }}, {{ contact?.stateId ? contact.stateId : '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Work Phone</span>
                        <span class="tw-text-right">{{ contact?.workPhone ? (contact.work_phone_country_code.country.countryCode + ' ' + (contact.workPhone | phone: contact.work_phone_country_code.country.countryCode)) : '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Zip Code</span>
                        <span class="tw-text-right">{{ contact?.zipId ? contact.zipId : '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <ng-container *ngIf="!(contact.isBusiness)">
                            <span class="tw-text-left">Social Security</span>
                            <span class="tw-text-right">{{ contact?.ssnGuarded ? (contact.ssnGuarded.toString() | ssn) : '-' }}</span>
                        </ng-container>
                        <ng-container *ngIf="!!(contact.isBusiness)">
                            <span class="tw-text-left">EIN</span>
                            <span class="tw-text-right">{{ contact?.ein || '-' }}</span>
                        </ng-container>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Email</span>
                        <span class="tw-text-right">{{ contact?.email ? contact.email : '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-items-center tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <ng-container *ngIf="!(contact.isBusiness)">
                            <span class="tw-text-left">Date of Birth</span>
                            <span class="tw-text-right">{{ contact?.birthDate ? (contact.birthDate | date) : '-' }}</span>
                        </ng-container>
                    </td>
                </tr>
            </ng-container>
        </ng-container>

        <!-- Business Contact -->
        <ng-container *ngIf="title === 'Business Contact'">
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Primary Phone</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Primary Phone') ? (getMetaDataFromDataList('Primary Phone', 'countryCode') + ' ' + (getValueFromDataList('Primary Phone') | phone: getMetaDataFromDataList('Primary Phone', 'countryCode'))) : '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">City</span>
                    <span class="tw-text-right">{{ getValueFromDataList('City') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Can Text</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Can Text') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">State</span>
                    <span class="tw-text-right">{{ getValueFromDataList('State') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Street</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Street') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Zip Code</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Zip Code') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Street 2</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Street2') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Borrower Zip Extra</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Borrower Zip Extra') || '-' }}</span>
                </td>
            </tr>
        </ng-container>

        <!-- Owner Overview -->
        <ng-container *ngIf="title === 'Owner Overview'">
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Had a Bankruptcy</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Had a Bankruptcy') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Street</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Owner Street') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Bankruptcy Status</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Bk. Status') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Street 2</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Owner Street 2') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Bankruptcy Chapter</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Bk. Chapter') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">City</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Owner City') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Bankruptcy Discharge Date</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Bk. Discharge Date') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">State</span>
                    <span class="tw-text-right">{{ getValueFromDataList('State') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Owner Birth Date</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Owner Birth Date') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Zip Code</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Zip Code') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Owner Phone Number</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Owner Phone Number') ? (getMetaDataFromDataList('Owner Phone Number', 'countryCode') + ' ' + (getValueFromDataList('Owner Phone Number') | phone: getMetaDataFromDataList('Owner Phone Number', 'countryCode'))) : '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Personal Income</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Personal Income') || '-' }}</span>
                </td>
            </tr>
        </ng-container>

        <!-- Business Overview -->
        <ng-container *ngIf="title === 'Business Overview'">
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Fex/State Tax ID (EIN)</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Fed/State Tax ID') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Authorized Owner</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Authorized Owner') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Place of Business</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Place of Business') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Location Ownership Type</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Location Ownership') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Managing Partners</span>
                    <span class="tw-text-right">{{ getValueFromDataList('# Add. Managing Partners') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Entity Type</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Entity Type') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Benificiary Owners</span>
                    <span class="tw-text-right">{{ getValueFromDataList('# Add. Beneficiary Owners') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Industry</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Industry') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">DBA</span>
                    <span class="tw-text-right">{{ getValueFromDataList('DBA Name') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Seasonal</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Is Seasonal') || '-' }}</span>
                </td>
            </tr>
            <tr class="tw-flex tw-w-full">
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                    <span class="tw-text-left">Business Start Date</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Business Start Date') || '-' }}</span>
                </td>
                <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                    <span class="tw-text-left">Non-Profit</span>
                    <span class="tw-text-right">{{ getValueFromDataList('Nonprofit') || '-' }}</span>
                </td>
            </tr>

            <mat-expansion-panel class="more-details-expansion"
                hideToggle
                (opened)="moreDetailsOpen = true"
                (closed)="moreDetailsOpen = false"
                >
                <mat-expansion-panel-header>
                    <div class="tw-flex tw-items-center tw-justify-center tw-text-sm tw-font-normal tw-text-center tw-w-full">
                        <mat-button
                          [color]="'primary'">
                          More Details
                          <mat-icon>{{ moreDetailsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </mat-button>
                    </div>
                </mat-expansion-panel-header>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Amex Merchant</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Amex Merchant') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Amex Merchant ID</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Amex Merchant ID') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Accept CCs</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Accepts CCs') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Monthly CCs</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Monthly CCs') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Landlord Name</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Landlord Name') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Outstanding Invoices</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Outstanding Invoices') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Primary Customer</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Primary Customer') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Website</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Website') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">State of Incorporation</span>
                        <span class="tw-text-right">{{ getValueFromDataList('State of Incorporation') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Number of Employees</span>
                        <span class="tw-text-right">{{ getValueFromDataList('# Employees') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Location Payment</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Location Payment') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Equipment Description</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Equip. Description') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">Location Ownership</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Location Ownership') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">Company Officer</span>
                        <span class="tw-text-right">{{ getValueFromDataList('Company Officer') || '-' }}</span>
                    </td>
                </tr>
                <tr class="tw-flex tw-w-full">
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4 tw-border-r divider-border">
                        <span class="tw-text-left">UCC Secured Party</span>
                        <span class="tw-text-right">{{ getValueFromDataList('UCC Secured Party') || '-' }}</span>
                    </td>
                    <td class="tw-flex tw-justify-between tw-w-1/2 tw-py-3 tw-pr-6 tw-pl-4">
                        <span class="tw-text-left">UCC Filing Date</span>
                        <span class="tw-text-right">{{ getValueFromDataList('UCC Filing Date') || '-' }}</span>
                    </td>
                </tr>
            </mat-expansion-panel>

        </ng-container>

      </table>
    </div>

    <div *ngIf="loading" style="display: flex; justify-content: center; padding: 20px;">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
